module.exports = __webpack_public_path__ + "img/1.5cb77d04.jpg";